import { CacheWithExpiration } from '@ms/yammer-data/dist/cache';

import VivaConnectionsStorage from './mobileEmbedViewStorage';

export default class VivaConnectionsCache extends CacheWithExpiration {
  constructor(keyNamespace: string) {
    super(new VivaConnectionsStorage(), keyNamespace);
  }
}
